import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorPopupData } from '@app/@core/models/error-popup-data.model';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
  standalone: false,
})
export class ErrorPopupComponent implements OnInit {
  errorMsg = '';
  dir: string;

  constructor(
    private dialogRef: MatDialogRef<ErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorPopupData,
  ) {}

  ngOnInit(): void {
    this.dir = localStorage.getItem('html-dir');
    const error = this.data?.error;
    if (error) {
      if (error instanceof Object) {
        const errorBody = (error as Record<string, unknown>).error;
        const nestedError = (errorBody as Record<string, unknown> | undefined)
          ?.error;
        this.errorMsg = nestedError
          ? String(nestedError)
          : JSON.stringify(errorBody);
      } else {
        this.errorMsg = error;
      }
    } else {
      this.errorMsg = JSON.stringify(this.data);
    }
  }

  action() {
    if (this.data && this.data.action && this.data.action.emit) {
      this.data.action.emit();
      this.dialogRef.close();
    }
  }
}
